import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'countryIso2',
  standalone: true,
})
export class CountryIso2Pipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const map: Record<string, string> = {
      FR: 'France',
      BE: 'Belgique',
      CH: 'Suisse',
      LU: 'Luxembourg',
      GB: 'Royaume-Uni',
      DE: 'Allemagne',
      ES: 'Espagne',
      IT: 'Italie',
      PT: 'Portugal',
      NL: 'Pays-Bas',
      US: 'États-Unis',
      CA: 'Canada',
    };

    return map[value.toUpperCase()] ?? value;
  }
}
